import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateAccountComponent } from './create-account/create-account.component';
import { RegistrationComponent } from './registration.component';
import { CodeVerificationComponent } from './code-verification/code-verification.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { RegComponent } from './registration-base/registration-base.component';
import { BaseCodeVerificationComponent } from './base-code-verification/base-code-verification.component';
import { BaseEmailVerificationComponent } from './base-email-verification/base-email-verification.component';

const registrationRoutes: Routes = [
	{
		path: '',
		component: RegistrationComponent,
		data: {
			title: '',
		},
		children: [
			{
				path: '',
				component: RegComponent,
				pathMatch: 'prefix',
				data: {
					title: 'Create Account',
				},
			},
			{
				path: 'verification/code',
				component: BaseCodeVerificationComponent,
				pathMatch: 'prefix',
				data: {
					title: 'Security Code',
				},
			},
			{
				path: 'verification/email',
				component: BaseEmailVerificationComponent,
				pathMatch: 'prefix',
				data: {
					title: 'Email Verification',
				},
			},
		],
	},
	{
		path: 'embed/signup',
		component: CreateAccountComponent,
		data: {
			title: 'Sign UP',
		},
	},
	{
		path: 'embed/verification/code',
		component: CodeVerificationComponent,
		data: {
			title: 'Verification Code',
		},
	},
	{
		path: 'embed/verification/email',
		component: EmailVerificationComponent,
		data: {
			title: 'Verification Email',
		},
	},
];

@NgModule({
	imports: [RouterModule.forChild(registrationRoutes)],
	exports: [RouterModule],
})
export class RegistrationRoutingModule {}
